module.exports = __webpack_public_path__ + "img/blessing_prize_4.4e53e765.png";